<template>
  <CommonPopup ref="refCommonPopup">
    <div class="pay-result-popup">
      <div class="pay-result-popup-content">
        <img
          class="pay-result-icon"
          src="@/assets/img/chargingVoucher/icon-pay-success.png"
        >
        <div class="pay-result-title">支付成功</div>
        <div class="pay-result-info">
          {{ text }}
        </div>
      </div>
      <div
        class="pay-result-popup-btn"
        @click="confirm"
      >确定</div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';

export default {
  name: 'PayResultPopup',
  components: {
    CommonPopup
  },
  data() {
    return {
      text: ''
    };
  },
  methods: {
    openPopup(text = '') {
      this.text = text;
      this.$refs.refCommonPopup.openPopup();
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
    },
    confirm() {
      this.$emit('confirm');
      this.closePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-result-popup {
  background: #ffffff;
  border-radius: 20px;
  width: 600px;
  height: 577px;
  box-sizing: border-box;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .pay-result-popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .pay-result-icon {
      width: 72px;
      height: 72px;
      margin-top: 40px;
      margin-bottom: 24px;
    }
    .pay-result-title {
      font-size: 40px;
      color: #383838;
      text-align: center;
      font-weight: bold;
      line-height: 56px;
      margin-bottom: 24px;
    }
    .pay-result-info {
      font-size: 32px;
      color: #787878;
      font-weight: 400;
      line-height: 45px;
    }
  }
  .pay-result-popup-btn {
    background: #fe7256;
    border-radius: 40px;
    width: 100%;
    height: 90px;
    font-size: 32px;
    color: #ffffff;
    text-align: center;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
